export const config = {
  environment: 'uat',
  apiUrl: 'https://acai-odm-uat-backend-esecfqhxcuddgwg7.germanywestcentral-01.azurewebsites.net',

  // Azure AD Authentication
  azureClientId: '987c59bd-28f8-4044-9533-2c797df27ec5',
  azureTenantId: '6e06e42d-6925-47c6-b9e7-9581c7ca302a',
  msalRedirectUri: 'https://odm-uat.allianz.com',

  // Azure AD Security Groups (UAT)
  adminGroupId: 'a8ba5c77-63fb-49d8-98db-617bb1335b56',
  requestorGroupId: '6cbccd42-93fd-4cca-b33b-115813e80204'
};
